<template>
  <div>
    <div v-for="(item, index) in visits.data" :key="'register-visit' + index">
      <validation-observer
        ref="registerVisitForm"
        novalidate
        tag="form"
        @submit.prevent="handleSaveVisit"
      >
        <custom-callout
          class="mb-3 custom-callout"
          :controlled="true"
          :opened="item.isOpen"
          @click:open="onToggleAdditionalInfo(item, index)"
        >
          <div class="row">
            <div class="col-md-1 col-spacing hour-size">
              <div class="color-secondary-6 font-weight-normal font-14">
                Día:
              </div>
              <validation-provider
                v-if="!item.saved"
                v-slot="{ errors }"
                name="Día"
                rules="required"
              >
                <custom-input
                  v-model="item.day"
                  class="hour-size"
                  custom-error-msg=""
                  :error="errors[0]"
                  mask-type="Day"
                  type="text"
                />
              </validation-provider>
              <span v-else class="color-black">{{ item.day }}</span>
            </div>
            <div class="col col-spacing">
              <div
                v-if="!item.saved"
                class="color-secondary-6 font-weight-normal font-14"
              >
                Hora Desde:
              </div>
              <div v-else class="color-secondary-6 font-weight-normal font-14">
                Hora:
              </div>
              <div v-if="!item.saved" class="d-flex">
                <validation-provider
                  v-slot="{ errors }"
                  name="HourStartHour"
                  rules="required"
                >
                  <custom-input
                    v-model="item.hourStartHour"
                    class="hour-size"
                    custom-error-msg=""
                    :error="errors[0]"
                    mask-type="Day"
                    type="text"
                  />
                </validation-provider>
                <span class="mr-3 mt-1">:</span>
                <validation-provider
                  v-slot="{ errors }"
                  name="HourStartMinute"
                  rules="required"
                >
                  <custom-input
                    v-model="item.hourStartMinute"
                    class="hour-size"
                    custom-error-msg=""
                    :error="errors[0]"
                    mask-type="Day"
                    type="text"
                  />
                </validation-provider>
                <b-form-select
                  v-model="item.hourStartTime"
                  class="ampm-size"
                  :options="timeOptions"
                />
              </div>
              <div v-else>
                <span class="color-black">
                  {{ getHourRange(item) }}
                </span>
              </div>
            </div>
            <div v-if="!item.saved" class="col col-spacing">
              <div class="color-secondary-6 font-weight-normal font-14">
                Hora Hasta:
              </div>
              <div v-if="!item.saved" class="d-flex">
                <validation-provider
                  v-slot="{ errors }"
                  name="hourEnd"
                  rules="required"
                >
                  <custom-input
                    v-model="item.hourEnd"
                    class="hour-size"
                    custom-error-msg=""
                    :error="errors[0]"
                    mask-type="Day"
                    type="text"
                  />
                </validation-provider>
                <span class="mr-3 mt-1">:</span>
                <validation-provider
                  v-slot="{ errors }"
                  name="hourEndMinute"
                  rules="required"
                >
                  <custom-input
                    v-model="item.hourEndMinute"
                    class="hour-size"
                    custom-error-msg=""
                    :error="errors[0]"
                    mask-type="Day"
                    type="text"
                  />
                </validation-provider>
                <b-form-select
                  v-model="item.hourEndTime"
                  class="ampm-size"
                  :options="timeOptions"
                />
              </div>
            </div>
            <div
              class="col-md-3 col-spacing"
              :class="{ 'col-md-4': item.saved }"
            >
              <div class="color-secondary-6 font-weight-normal font-14">
                Tipo:
              </div>
              <span v-if="!item.saved">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="SelectedType"
                  rules="required"
                >
                  <CustomDropDown
                    v-model="item.selectedType"
                    :disabled="item.id"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    :options="visitTypes"
                    :clearable="false"
                    @input="handleChangeVisitType"
                  />
                </ValidationProvider>
                <div v-if="item.selectedType" class="mt-2">
                  <span class="color-secondary-6 font-weight-normal font-14">
                    Año Anterior:
                  </span>
                  <ValidationProvider v-slot="{ errors }" rules="required">
                    <CustomDropDown
                      v-model="item.previousAcademicYear"
                      :error="errors[0]"
                      fieldkey="id"
                      fieldname="description"
                      :options="compensatoryYears"
                      @input="handleChangeCompensatoryYear(item)"
                    />
                  </ValidationProvider>
                </div>
                <div
                  v-if="
                    item.selectedType &&
                      item.previousAcademicYear &&
                      item.previousAcademicYear.id > 0
                  "
                  class="mt-2"
                >
                  <span class="color-secondary-6 font-weight-normal font-14">
                    Solicitud:
                  </span>
                  <ValidationProvider v-slot="{ errors }" rules="required">
                    <CustomDropDown
                      v-model="item.compensatoryRequestSelected"
                      :error="errors[0]"
                      fieldkey="id"
                      fieldname="name"
                      :options="filteredCompensatoryNumbers"
                    />
                  </ValidationProvider>
                </div>
              </span>
              <span v-else class="color-black">
                {{ getItemName(item.selectedType) }}
              </span>
            </div>
            <div
              v-if="!isPeriodFinalized"
              class="col-md-2 justify-content-center align-items-center pt-4 mt-1"
              :class="{
                'col-md-3': item.saved,
              }"
            >
              <div
                v-if="enableActionMenu(item) && !item.enableReplaceSpecialist"
                class="dropdown"
              >
                <button
                  id="dropdownMenuButton"
                  aria-expanded="false"
                  aria-haspopup="true"
                  class="btn btn-dropdown-actions dropdown-toggle float-right pt-1"
                  data-toggle="dropdown"
                  type="button"
                >
                  Acciones
                </button>
                <div
                  aria-labelledby="dropdownMenuButton"
                  class="dropdown-menu dropdown-menu-right custom-dropdown-container"
                >
                  <div
                    class="dropdown-item cursor-pointer mb-1"
                    @click="editVisit(item, index)"
                  >
                    <em class="fa fa-pencil text-green pr-1" />
                    <span>Editar Visita</span>
                  </div>
                  <div
                    class="dropdown-item cursor-pointer"
                    @click="onDeleteVisit(item.id, index)"
                  >
                    <em class="fa fa-times-circle text-red pr-1" />
                    <span>Eliminar Visita</span>
                  </div>
                </div>
              </div>
              <div
                v-if="enableActionButton(item)"
                class="mt-n3 d-flex align-items-center justify-content-end"
              >
                <action-button
                  v-if="
                    (!item.saved && item.id) || item.enableReplaceSpecialist
                  "
                  class="px-4 mt-4"
                  i="fas fa-times-circle"
                  variant="outline-danger btn-cancel danger"
                  @click="onCancelEdit(item, index)"
                >
                  Cancelar
                </action-button>
                <action-button
                  class="px-4 mt-4 ml-3"
                  i="fas fa-save"
                  text="Guardar"
                  variant="success"
                  @click="handleSaveVisit(item, item.id, index)"
                />
              </div>
            </div>
          </div>
        </custom-callout>
        <div
          v-if="item.errors || item.validations"
          class="visit-error-container"
        >
          <error
            v-for="(error, errorIndex) in item.validations"
            :key="`validation-container-visit` + errorIndex"
            :message="error"
            variant="no-border"
          />
          <error
            v-for="(error, errorIndex) in item.errors"
            :key="`error-container-visit` + errorIndex"
            :message="error"
            variant="no-border"
          />
        </div>
      </validation-observer>
    </div>
  </div>
</template>

<script>
//third party libs
import _ from 'lodash';
import moment from 'moment';
import 'moment/locale/es-do';

// component libs
import Error from 'custom-error';
import CustomInput from 'CustomInput';
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import CustomCallout from 'custom-callout';
import Checkbox from 'CheckBox';

// constants
import visitTypesEnum from '@/utils/constants/visit-registry/visitTypes.js';

import {
  getVisits as _getVisits,
  saveVisit as _saveVisit,
  deleteVisit as _deleteVisit,
  getAcademicYearsAndCompensatoryNumbers as _getAcademicYearsAndCompensatoryNumbers,
} from '@/services/pei/visit-registry.js';

//mixins
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

export default {
  name: 'RegisterEducationalVisit',
  components: {
    CustomCallout,
    CustomInput,
    CustomDropDown,
    ActionButton,
    Error,
    Checkbox,
  },
  mixins: [alertMixin],
  props: {
    studentInfo: {
      type: Object,
      default: () => {},
    },
    isPeriodFinalized: {
      type: Boolean,
      default: () => false,
    },
    visitTypes: {
      type: Array,
      default: () => [],
    },
    selectedPeriod: {
      type: Object,
      default: () => ({
        year: null,
        monthNumber: null,
      }),
    },
  },
  data: () => ({
    visits: {
      data: [
        {}, // set entry mode
      ],
    },
    visitLocations: [],
    visitLocationServices: [],
    visitMunicipalities: [],
    visitRegions: [],
    visitDistricts: [],
    visitSchools: [],
    visitCenters: [],
    editVisitOriginalInfo: {},
    compensatoryYears: [],
    compensatoryNumbers: [],
    filteredCompensatoryNumbers: [],
  }),
  computed: {
    timeOptions() {
      return [
        { value: 'am', text: 'AM' },
        { value: 'pm', text: 'PM' },
      ];
    },
    getHourRange() {
      return (item) => {
        return (
          moment(
            `${item.hourStartHour}:${item.hourStartMinute} ${item.hourStartTime}`,
            'hh:mm A'
          )
            .format('h:mm A')
            .toLowerCase() +
          ' - ' +
          moment(
            `${item.hourEnd}:${item.hourEndMinute} ${item.hourEndTime}`,
            'hh:mm A'
          )
            .format('h:mm A')
            .toLowerCase()
        );
      };
    },
    enableActionButton() {
      return (item) =>
        (!item.saved && !this.isPeriodFinalized) ||
        item.enableReplaceSpecialist;
    },
    enableActionMenu() {
      return (item) => item.saved || item.enableReplaceSpecialist;
    },
    enableReplaceSpecialist() {
      return (item) => (item.enableReplaceSpecialist ? true : false);
    },
    getItemName() {
      return (item) => {
        return item?.id ? item.name : '';
      };
    },
    visitAcademicYearId() {
      return this.studentInfo.academicYearId;
    },
    visitCompanyId() {
      return this.studentInfo.companyId;
    },
  },
  watch: {
    selectedPeriod: {
      handler(newValue) {
        if (newValue?.year && newValue?.monthNumber) {
          this.getVisitList();
        }
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    isHourEndOverLimit(item) {
      const from = moment(
        `${item.hourStartHour}:${item.hourStartMinute} ${item.hourStartTime}`,
        'hh:mm A'
      );
      const to = moment(
        `${item.hourEnd}:${item.hourEndMinute} ${item.hourEndTime}`,
        'hh:mm A'
      );
      const isFrom7a = from.isSameOrAfter(moment('7:00 AM', 'hh:mm A'));
      const isAfter8p = to.isSameOrBefore(moment('8:00 PM', 'hh:mm A'));
      let isOnTimeSlot = isFrom7a && isAfter8p ? true : false;
      return isOnTimeSlot;
    },
    isAfterValidityDate(day) {
      return true;
      const assigmentStartDateEn = moment(this.studentInfo.assignmentStartDate)
        .locale('en-US')
        .format('DD/MMM/YYYY');

      const visitDateEn = moment(this.getVisitDate(day))
        .locale('en-US')
        .format('DD/MMM/YYYY');

      return Date.parse(assigmentStartDateEn) <= Date.parse(visitDateEn);
    },
    onToggleAdditionalInfo(item, itemIndex) {
      this.visits = {
        ...this.visits,
        data: this.visits.data.map((s, index) => {
          if (index === itemIndex) {
            s.isOpen = !s.isOpen;
          } else {
            s.isOpen = false;
          }
          return s;
        }),
      };
    },
    onCancelEdit(item, itemIndex) {
      if (item?.id) {
        this.visits = {
          ...this.visits,
          data: this.visits.data.map((s, index) => {
            if (index === itemIndex) {
              s.saved = true;
              s.isOpen = false;
              s.day = this.editVisitOriginalInfo.day;
              s.hourStartHour = this.editVisitOriginalInfo.hourStartHour;
              s.hourStartMinute = this.editVisitOriginalInfo.hourStartMinute;
              s.hourStartTime = this.editVisitOriginalInfo.hourStartTime;
              s.hourEnd = this.editVisitOriginalInfo.hourEnd;
              s.hourEndMinute = this.editVisitOriginalInfo.hourEndMinute;
              s.hourEndTime = this.editVisitOriginalInfo.hourEndTime;
            } else {
              s.isOpen = false;
            }
            return s;
          }),
        };
      }
    },
    async handleSaveVisit(item, saveEdit, index) {
      const isValid = await this.$refs.registerVisitForm[index].validate();
      const _validations = this.validateVisitEntry(item, index);

      if (isValid && _validations.length === 0) {
        this.updateVisitEntry(index, { validations: null });

        //El slice se usa para quitar el timezone del user.
        const visitDate = moment([
          this.selectedPeriod.year,
          this.selectedPeriod.monthNumber - 1,
          item.day,
        ])
          .format()
          .slice(0, -6);

        const timeStartFull = moment([
          this.selectedPeriod.year,
          this.selectedPeriod.monthNumber - 1,
          item.day,
          this.parseHour(item.hourStartTime, item.hourStartHour),
          item.hourStartMinute,
        ])
          .format()
          .slice(0, -6);

        const timeEndFull = moment([
          this.selectedPeriod.year,
          this.selectedPeriod.monthNumber - 1,
          item.day,
          this.parseHour(item.hourEndTime, item.hourEnd),
          item.hourEndMinute,
        ])
          .format()
          .slice(0, -6);

        const periodDate = new Date(
          this.selectedPeriod.year,
          this.selectedPeriod.monthNumber - 1,
          1
        );

        const dataToSend = {
          visitId: item.id ?? null,
          compensatoryRequestId: item.compensatoryRequestSelected?.id,
          studentSieId: this.studentInfo.studentSieId,
          timeStart: timeStartFull,
          timeEnd: timeEndFull,
          date: visitDate,
          academicYearId: this.studentInfo.academicYearId,
          monthNumber: this.selectedPeriod.monthNumber,
          year: this.selectedPeriod.year,
          filteredPeriodDate: periodDate,
          visitTypeId: item.selectedType?.id ?? null,
          centerId: this.studentInfo.centerId,
          companyId: this.studentInfo.companyId,
          comment: item.visitInfoComment,
          previousAcademicYearId: item.previousAcademicYear?.id,
          compensatoryRequestIdSelected: item.compensatoryRequestSelected?.id,
        };

        await _saveVisit(dataToSend)
          .then(() => {
            this.ShowToast(
              'Proceso exitoso.',
              'Sus datos han sido guardados exitosamente.',
              'success'
            );
            this.getVisitList();
            this.updateVisitEntry(index, { isOpen: false });
          })
          .catch((r) => {
            this.ShowToast('Alerta', r.response.data.message, 'error');
          });
      } else {
        this.updateVisitEntry(index, { validations: _validations });
      }
    },
    async handleChangeVisitType(value) {
      if (value?.id) {
        await this.getAcademicYearsAndCompensatoryNumbers();
      }
    },
    async handleChangeCompensatoryYear(item) {
      const previousAcademicYearIdSelected = item?.previousAcademicYear?.id;
      if (previousAcademicYearIdSelected > 0) {
        this.filteredCompensatoryNumbers = this.compensatoryNumbers.filter(
          (x) => x.academicYearId == previousAcademicYearIdSelected
        );
        if (
          this.filteredCompensatoryNumbers.findIndex(
            (x) => x.id === item?.compensatoryRequestSelected?.id
          ) === -1
        ) {
          item.compensatoryRequestSelected = null;
        }
      } else {
        this.filteredCompensatoryNumbers = [];
        item.compensatoryRequestSelected = null;
      }
    },
    getPeriodDate() {
      return moment()
        .year(this.selectedPeriod.year)
        .month(this.selectedPeriod.monthNumber - 1)
        .date(1)
        .toDate();
    },
    async getVisitList() {
      const { data: response } = await _getVisits(
        this.studentInfo.studentSieId,
        moment()
          .date(1)
          .month(this.selectedPeriod.monthNumber - 1)
          .year(this.selectedPeriod.year)
          .toDate(),
        parseInt(this.selectedPeriod.monthNumber)
      );
      if (response) {
        const result = response.map((x) => {
          const startHour = moment(x.visitTimeStart, 'HH:mm:ss').hours();
          const startMinute = moment(x.visitTimeStart, 'HH:mm:ss').minutes();

          const hourStartFormat = moment().set({
            hour: startHour,
            minute: startMinute,
          });

          const endHour = moment(x.visitTimeEnd, 'HH:mm:ss').hours();
          const endMinute = moment(x.visitTimeEnd, 'HH:mm:ss').minutes();

          const hourEndFormat = moment().set({
            hour: endHour,
            minute: endMinute,
          });

          x.hourStartHour = hourStartFormat.format('h');
          x.hourStartTime = hourStartFormat.format('A').toLowerCase();

          x.hourEnd = hourEndFormat.format('h').toLowerCase();
          x.hourEndMinute = hourEndFormat.format('m').toLowerCase();
          x.hourEndTime = hourEndFormat.format('A').toLowerCase();

          x.saved = true;

          return x;
        });

        this.visits = {
          data: this.isPeriodFinalized ? [...result] : [...result, {}],
        };
      }
    },
    async editVisit(item, itemIndex) {
      if (item?.id) {
        await this.getAcademicYearsAndCompensatoryNumbers();
        this.editVisitOriginalInfo = { ...item };
        this.visits = {
          ...this.visits,
          data: this.visits.data.map((s, index) => {
            if (index === itemIndex) {
              s.saved = false;
            } else {
              if (s.id) {
                s.saved = true;
                s.isOpen = false;
              }
            }
            return s;
          }),
        };
      }
    },
    async onDeleteVisit(id) {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea eliminar la visita documentada?',
        'Sí',
        'No'
      );
      if (answer) {
        this.ShowToast(
          'Proceso Exitoso',
          'La información fue actualizada exitosamente.',
          'success'
        );
        await _deleteVisit(id);
        this.getVisitList();
      }
    },
    async getAcademicYearsAndCompensatoryNumbers() {
      const response = await _getAcademicYearsAndCompensatoryNumbers(
        this.studentInfo.studentSieId,
        this.studentInfo.disciplineTypeId ?? this.studentInfo.disciplineType?.id
      );
      if (response?.data) {
        this.compensatoryYears = response.data.years;
        this.compensatoryNumbers = response.data.compensatories;
      }
    },
    validateVisitEntry(item) {
      const validations = [];
      const _hourIsValid = this.isHourValid(item);
      const _isValidHourEnd = item.hourEnd
        ? this.isValidHourEnd(
            `${item.hourStartHour}:${item.hourStartMinute} ${item.hourStartTime}`,
            `${item.hourEnd}:${item.hourEndMinute} ${item.hourEndTime}`
          )
        : true;

      if (!this.periodValidation(item.day)) {
        validations.push(
          'No se identificó vigencia de servicio para el día de visita.'
        );
      }

      const _visitDayIsFuture = this.visitDayIsFuture(item.day);
      const _isWeekend = this.isWeekend(item.day);

      const _hourEndOverLimit = this.isHourEndOverLimit(item);
      const _visitIsAfterValidityDate = this.isAfterValidityDate(item.day);
      const { _hasDayValidRange, minimum, maximum } = this.hasDayValidRange(
        item.day
      );

      if (!_hasDayValidRange) {
        validations.push(
          `El día de la visita debe ser entre ${minimum} al ${maximum}.`
        );
      }

      if (!item.day) {
        validations.push('Favor de entrar el día de la visita.');
      }
      if (!item.hourStartHour || !item.hourStartMinute || !item.hourStartTime) {
        validations.push('Favor de entrar la hora de comienzo de la visita.');
      }
      if (!item.selectedType?.id) {
        validations.push('Favor de seleccionar el tipo de visita.');
      }
      if (item.selectedType && !item.previousAcademicYear?.id) {
        validations.push('Favor de seleccionar el año académico anterior.');
      }
      if (
        item.selectedType &&
        item.previousAcademicYear?.id &&
        !item.compensatoryRequestSelected?.id
      ) {
        validations.push('Favor de seleccionar la solicitud.');
      }
      if (!item.hourEnd || !item.hourEndMinute || !item.hourEndTime) {
        validations.push('Favor de entrar la hora de fin de la visita.');
      }
      if (!_hourIsValid) {
        validations.push('La hora no es válida');
      }
      if (!_isValidHourEnd) {
        validations.push('La hora hasta debe ser mayor a la hora desde.');
      }
      if (_visitDayIsFuture) {
        validations.push('El día de la visita no puede ser al futuro.');
      }
      if (_isWeekend) {
        validations.push('No se pueden registrar visitas los fines de semana.');
      }
      if (!_hourEndOverLimit) {
        validations.push(
          'El horario de la visita sobrepasa el límite permitido (7:00am a 8:00pm).'
        );
      }
      if (!_visitIsAfterValidityDate) {
        validations.push(
          'No se identificó vigencia de servicio para el día de visita.'
        );
      }
      return validations;
    },
    visitDayIsFuture(day) {
      let visitDate = this.getVisitDate(day);
      let currentDate = new Date();
      return visitDate > currentDate;
    },
    isWeekend(day) {
      if (!day) return false;

      let visitDate = this.getVisitDate(day);
      let dayOfWeek = visitDate.getDay();

      return dayOfWeek === 0 || dayOfWeek === 6;
    },
    getVisitDate(visitday) {
      if (!visitday) {
        return null;
      }

      return new Date(
        this.selectedPeriod.year,
        this.selectedPeriod.monthNumber - 1,
        parseInt(visitday)
      );
    },
    updateVisitEntry(entryIndex, prop) {
      if (prop) {
        this.visits = {
          ...this.visits,
          data: this.visits.data.map((item, index) => {
            if (entryIndex === index) {
              item = {
                ...item,
                ...prop,
              };
            }
            return item;
          }),
        };
      }
    },
    hasDayValidRange(day) {
      const minimum = 1;
      const maximum = 31;
      return {
        _hasDayValidRange: _.inRange(parseInt(day), minimum, maximum + 1),
        minimum,
        maximum,
      };
    },
    isHourValid(item) {
      const _values = this.getEntryValues(item);

      const hour = parseInt(_values.hour, 10);
      const min = _values.min;
      const ampm = _values.ampm;

      const visitHour = moment(`${hour}:${min} ${ampm}`, 'h:mm A', true);

      return visitHour.isValid();
    },
    getEntryValues(item) {
      return {
        hour: item.hourStartHour,
        min: item.hourStartMinute,
        ampm: item.hourStartTime,
      };
    },
    isValidHourEnd(startHour, endHour) {
      const from = moment(startHour, 'hh:mm A');
      const to = moment(endHour, 'hh:mm A');
      return to.isAfter(from) && !to.isSame(from);
    },
    parseHour(time, hour) {
      if (hour == 12) {
        return parseInt(hour);
      }
      return time.toLowerCase() == 'pm' ? parseInt(hour) + 12 : hour;
    },
    periodValidation(day) {
      return true;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables/_colors.scss';
.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 86px;
  .toggle-icon {
    flex: 1;
    cursor: pointer;
    text-align: center;
    em {
      margin-top: 12px;
      font-size: 26px;
    }
  }
  .separator-line {
    background: transparent linear-gradient(270deg, #f7f7f700 0%, #efefef 100%)
      0% 0% no-repeat padding-box;
    opacity: 1;
    width: 10px;
    height: 100%;
  }
}
.orange-color {
  color: #ff7058;
}
.green-color {
  color: #2db782;
}
.hour-size {
  width: 60px;
  margin-right: 10px;
}
.ampm-size {
  width: 80px;
  margin-right: 10px;
}

/* overrides */
.custom-callout {
  .col-spacing {
    padding: 11px 11px;
  }
  ::v-deep .callout-container {
    padding: 0px !important;
    border-left-width: 0px;
  }
  ::v-deep .collaut-edition {
    margin-top: 3px !important;
    padding: 7px !important;
  }
}

::v-deep .custom-nav-container {
  border-bottom: 1px solid map-get($colors, 'gray-5');
  .nav-item {
    .nav-link {
      color: map-get($colors, 'secondary-6');
      &.active {
        border-bottom: 3px solid map-get($colors, 'green');
        color: map-get($colors, 'green');
      }
      &.active:after {
        content: unset;
      }
    }
  }
}

.custom-dropdown-container {
  max-width: 250px;
  min-width: 250px;
  .dropdown-item {
    white-space: unset;
    padding: 0.25rem 1rem;
    em {
      margin-right: 10px;
    }
  }
}

.visit-error-container {
  background: #fae7e7;
  padding: 10px;
  border-radius: 0px 0px 5px 5px;
  margin-top: -16px;
  margin-bottom: 20px;
}

.input-group .entry {
  height: 25px;
  position: relative;
  width: 110px;
}
.input-group .circle {
  border: 1px solid #e2e2e2;
  border-radius: 50%;
  cursor: pointer;
  height: 20px;
  position: absolute;
  transition: border-color 300ms;
  width: 20px;
}
.input-group .entry-label {
  cursor: pointer;
  font-weight: 800;
  margin-top: -3px;
  padding-left: 30px;
  user-select: none;
  -moz-user-select: none;
}
.input-group .highlight {
  background: #2db782;
  border-radius: 50%;
  height: 10px;
  left: 5px;
  pointer-events: none;
  position: absolute;
  top: 5px;
  transition: transform 400ms cubic-bezier(0.175, 0.885, 0.32, 1.2);
  transform: translateX(0px);
  width: 10px;
}
.input-group .hidden:nth-child(1):checked ~ .highlight {
  transform: translateY(0);
}
.input-group .hidden:nth-child(3):checked ~ .highlight {
  transform: translateX(110px);
}
.input-group .hidden:nth-child(1):checked + .entry .circle {
  border-color: #e2e2e2;
}
</style>
